import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicFatMetabolismCombined from "./index";

const CardiometabolicFatMetabolismWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicFatMetabolismCombined}
    keyControlsId="cardiometabolic-fat-metabolism-key"
    {...props}
  />
);

export default CardiometabolicFatMetabolismWithToggleKey;
